// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"e9b376c0b5c061dbb499","691":"fc7a39d6dc7c4ac22dd4"}[chunkId] + ".js";
};